import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "./api";

const AuthCtx = createContext(null);

// Cookie-based auth: no token in localStorage. Session is held in httpOnly cookie;
// we determine logged-in state by calling /auth/me on bootstrap.
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authApi.me().then(setUser).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await authApi.login({ email, password });
    setUser(res.user);
    return res.user;
  };
  const signup = async (data) => {
    const res = await authApi.signup(data);
    setUser(res.user);
    return res.user;
  };
  const logout = async () => {
    try { await authApi.logout(); } catch (e) { /* best effort */ }
    setUser(null);
    window.location.href = "/";
  };

  return <AuthCtx.Provider value={{ user, loading, login, signup, logout, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
